<template>
  <div class="mobile">
    <div class="mobileHeader">
      <img :src="imgs?.mobileLogo" alt="" class="mobileHeaderLogo" />
    </div>
    <img :src="imgs?.mobileBanner" alt="" class="mobileBanner" />
    <div class="mobileBody">
      <img :src="imgs.mobileBodyOverall" alt="" class="mobileBodyOverall" />
      <img :src="imgs?.mobileBodyOverallDetail" alt="" class="mobileBodyOverallDetail" />
      <img :src="imgs?.mobileBodyClass" alt="" class="mobileBodyClass" />
      <img :src="imgs?.mobileBodyClassDetail" alt="" class="mobileBodyClassDetail" />
      <div class="mobileTeach">
        <img
          src="https://p4.ssl.qhimg.com/t11b673bcd654b67ccb0e091a44.png"
          alt=""
          class="mobileTeachTitle"
        />
        <div class="safeClass">
          <img :src="safeClass?.avtar" alt="" class="safeClassAvtar" />
          <div class="safeClassHead">
            <div class="safeClassHeadType">{{ safeClass?.className }}</div>
            <div class="safeClassHeadBox">
              <span class="safeClassHeadBoxName">{{ safeClass?.teacher }}</span>
              <div class="safeClassHeadBoxInfo">
                <img :src="safeClass?.crown" alt="" class="safeClassHeadBoxAvtar" />
                <div class="safeClassHeadBoxLevel">{{ safeClass?.teacherLevel }}</div>
              </div>
            </div>
            <div class="safeClassHeadTitle">
              {{ safeClass?.teacherTitle }}
            </div>
          </div>
          <div class="safeClassIntro">
            {{ safeClass?.intro }}
          </div>
          <div class="safeClassList">
            <div
              v-for="(item, index) in safeClass?.studentsArr"
              :key="index"
              class="safeClassListItem"
            >
              <img :src="item.avtar" alt="" class="safeClassListItemAvtar" />
              <div class="safeClassListItemBox">
                <div class="safeClassListItemBoxName">{{ item.name }}</div>
                <div class="safeClassListItemBoxIntro">{{ item.intro }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="aiClass">
          <!-- <img :src="aiClass?.avtar" alt="" class="aiClassAvtar" /> -->
          <img
            src="https://p3.ssl.qhimg.com/t11b673bcd6f672c271a2bfd8ba.png"
            alt=""
            class="aiClassAvtar"
          />
          <div class="aiClassHead">
            <div class="aiClassHeadType">{{ aiClass?.className }}</div>
            <div class="aiClassHeadBox">
              <span class="aiClassHeadBoxName">{{ aiClass?.teacher }}</span>
              <div class="aiClassHeadBoxInfo">
                <img :src="aiClass?.crown" alt="" class="aiClassHeadBoxAvtar" />
                <div class="aiClassHeadBoxLevel">{{ aiClass?.teacherLevel }}</div>
              </div>
            </div>
            <div class="aiClassHeadTitle">
              {{ aiClass?.teacherTitle }}
            </div>
          </div>
          <div class="aiClassIntro">
            {{ aiClass?.intro }}
          </div>
          <div class="aiClassList">
            <div v-for="(item, index) in aiClass?.studentsArr" :key="index" class="aiClassListItem">
              <img :src="item.avtar" alt="" class="aiClassListItemAvtar" />
              <div class="aiClassListItemBox">
                <div class="aiClassListItemBoxName">{{ item.name }}</div>
                <div class="aiClassListItemBoxIntro">{{ item.intro }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img :src="imgs?.mobileBodySignup" alt="" class="mobileBodySignup" />
    </div>
    <div class="mobileQr">
      <img :src="imgs?.mobileQrCode" alt="" class="mobileQrCode" />
    </div>
    <div class="mobilePartner">
      <img
        src="https://p5.ssl.qhimg.com/t11b673bcd6b4464151864cd116.png"
        alt=""
        class="mobilePartnerTitle"
      />
      <!-- <img :src="imgs?.pcPartner" alt="" class="pcPartnerImg"> -->
      <div class="mobilePartnerBox">
        <img
          @click="jumbToPartner(item.id)"
          v-for="(item, index) in partners"
          :key="index"
          :src="item.photo"
          alt=""
          class="mobilePartnerBoxItem"
        />
      </div>
      <!-- <img :src="imgs?.mobilePartner" alt="" class="mobilePartnerImg"> -->
    </div>
    <div v-show="showImage" @click="scrollToBottom" class="mobileFooter">
      <img
        src="https://p3.ssl.qhimg.com/t11b673bcd64337f78643876d82.png"
        alt=""
        class="mobileJumpBottom"
      />
    </div>
  </div>
</template>

<script setup>
import { ref, onBeforeMount, onMounted, onUnmounted } from 'vue'

import { getRecruit } from '@/api/2024/index'

let aiClass = ref({})
let safeClass = ref({})
let imgs = ref({})
// let aiClass = ref({
//   className: 'AI课程',
//   teacher: '殷宇辉',
//   teacherLevel: '领衔导师',
//   teacherTitle: '360高级威胁研究院高级工程师',
//   avtar: 'https://p5.ssl.qhimg.com/t11b673bcd6cbd549f81e8a89eb.png',
//   crown: 'https://p4.ssl.qhimg.com/t11b673bcd635bec9e5ab95d33d.png',
//   intro:
//     'APT技术分析负责人，带领团队捕获多个APT攻击组织和在野0day漏洞，同时作为主要作者研发了360恶意程序自动化分析系统，以及作为核心人员参与360国产自主杀毒引擎国际评测并满分夺冠。',
//   studentsArr: [
//     {
//       name: '应之龙',
//       avtar: 'https://p4.ssl.qhimg.com/t11b673bcd66c9e3d2fb84bd6f6.png',
//       intro: '360数智化集团大模型应用产品专家'
//     },
//     {
//       name: '宋翰轩',
//       avtar: 'https://p0.ssl.qhimg.com/t11b673bcd68fe48048d518b8d5.png',
//       intro: '360数智化集团技术中台产品战略负责人'
//     },
//     {
//       name: '高献光',
//       avtar: 'https://p5.ssl.qhimg.com/t11b673bcd68d5e169ce9f77a88.png',
//       intro: '360企业云盘产品技术总监，智能文档云首席技术架构师'
//     },
//     {
//       name: '刘俊华',
//       avtar: 'https://p3.ssl.qhimg.com/t11b673bcd6f607158ed18ff5db.png',
//       intro: '360数智化集团智能产品解决方案总监，企业级大模型解决方案负责人'
//     },
//     {
//       name: '常宝宝',
//       avtar: 'https://p2.ssl.qhimg.com/t11b673bcd692a7c08e3786e4f6.png',
//       intro: '北京大学计算机学院副教授、博士生导师'
//     },
//     {
//       name: '沙磊',
//       avtar: 'https://p0.ssl.qhimg.com/t11b673bcd6a6f4084088753f5d.png',
//       intro: '北京航空航天大学人工智能学院教授，博士生导师'
//     },
//     {
//       name: '周长江',
//       avtar: 'https://p3.ssl.qhimg.com/t11b673bcd6dda88bde850a0d25.png',
//       intro: '360技术中台产品专家、大模型开发平台产品负责人'
//     },
//     {
//       name: '张伟',
//       avtar: 'https://p5.ssl.qhimg.com/t11b673bcd63d217b3f9da97ef4.png',
//       intro: '360数智化集团大模型应用产品专家'
//     }
//   ]
// })

// let safeClass = ref({
//   className: '数字安全课程',
//   teacher: '潘剑锋',
//   teacherLevel: '领衔导师',
//   teacherTitle: '360高级威胁研究院高级工程师',
//   avtar: 'https://p5.ssl.qhimg.com/t11b673bcd6cbd549f81e8a89eb.png',
//   crown: 'https://p4.ssl.qhimg.com/t11b673bcd635bec9e5ab95d33d.png',
//   intro:
//     'APT技术分析负责人，带领团队捕获多个APT攻击组织和在野0day漏洞，同时作为主要作者研发了360恶意程序自动化分析系统，以及作为核心人员参与360国产自主杀毒引擎国际评测并满分夺冠。',
//   studentsArr: [
//     {
//       name: '应之龙',
//       avtar: 'https://p4.ssl.qhimg.com/t11b673bcd66c9e3d2fb84bd6f6.png',
//       intro: '360数智化集团大模型应用产品专家'
//     },
//     {
//       name: '宋翰轩',
//       avtar: 'https://p0.ssl.qhimg.com/t11b673bcd68fe48048d518b8d5.png',
//       intro: '360数智化集团技术中台产品战略负责人'
//     },
//     {
//       name: '高献光',
//       avtar: 'https://p5.ssl.qhimg.com/t11b673bcd68d5e169ce9f77a88.png',
//       intro: '360企业云盘产品技术总监，智能文档云首席技术架构师'
//     },
//     {
//       name: '刘俊华',
//       avtar: 'https://p3.ssl.qhimg.com/t11b673bcd6f607158ed18ff5db.png',
//       intro: '360数智化集团智能产品解决方案总监，企业级大模型解决方案负责人'
//     },
//     {
//       name: '常宝宝',
//       avtar: 'https://p2.ssl.qhimg.com/t11b673bcd692a7c08e3786e4f6.png',
//       intro: '北京大学计算机学院副教授、博士生导师'
//     },
//     {
//       name: '沙磊',
//       avtar: 'https://p0.ssl.qhimg.com/t11b673bcd6a6f4084088753f5d.png',
//       intro: '北京航空航天大学人工智能学院教授，博士生导师'
//     },
//     {
//       name: '周长江',
//       avtar: 'https://p3.ssl.qhimg.com/t11b673bcd6dda88bde850a0d25.png',
//       intro: '360技术中台产品专家、大模型开发平台产品负责人'
//     },
//     {
//       name: '张伟',
//       avtar: 'https://p5.ssl.qhimg.com/t11b673bcd63d217b3f9da97ef4.png',
//       intro: '360数智化集团大模型应用产品专家'
//     }
//   ]
// })
// let imgs = ref({
//   pcLogoImg: 'https://p5.ssl.qhimg.com/t11b673bcd6fe1255f4a83753eb.png',
//   pcBanner: 'https://p1.ssl.qhimg.com/t11b673bcd64d7a3291b772c49a.png',
//   pcOverviewImg: 'https://p4.ssl.qhimg.com/t11b673bcd6808bd6eeb17366b9.png',
//   pcClassImg: 'https://p5.ssl.qhimg.com/t11b673bcd6b6a780051c4dfe74.png',
//   pcSignupImg: 'https://p2.ssl.qhimg.com/t11b673bcd66564595b751b60ad.png',
//   mobileLogo: 'https://p0.ssl.qhimg.com/t11b673bcd6ddb1a4b59e3b3f97.png',
//   mobileBanner: 'https://p2.ssl.qhimg.com/t11b673bcd644bf8e33d6c71019.png',
//   mobileBodyOverall: 'https://p4.ssl.qhimg.com/t11b673bcd6224273d0797754c8.png',
//   mobileBodyOverallDetail: 'https://p2.ssl.qhimg.com/t11b673bcd66f290ea1a944db17.png',
//   mobileBodyClass: 'https://p5.ssl.qhimg.com/t11b673bcd6e8d6403d1dbf7d0a.png',
//   mobileBodyClassDetail: 'https://p4.ssl.qhimg.com/t11b673bcd63caaea10af59bf22.png',
//   mobileBodySignup: 'https://p2.ssl.qhimg.com/t11b673bcd6016abda5a235b4d1.png',
//   mobileQrCode: 'https://p2.ssl.qhimg.com/t11b673bcd6b42f9658c1e4506a.png'
// })
let lastScrollY = window.scrollY
const showImage = ref(true)

const scrollToBottom = () => {
  window.scrollTo({
    top: document.body.scrollHeight,
    behavior: 'smooth'
  })
  showImage.value = false
}

const handleScroll = () => {
  const currentScrollY = window.scrollY
  const bottomThreshold = document.documentElement.scrollHeight - window.innerHeight

  if (currentScrollY >= bottomThreshold) {
    showImage.value = false
  } else if (currentScrollY < lastScrollY) {
    showImage.value = true
  }

  lastScrollY = currentScrollY
}

const jumbToPartner = (id) => {
  if (id === 'snow') {
    window.open('https://www.kanxue.com/book-leaflet-185.htm', '_blank')
  } else if (id === 'service') {
    window.open('http://www.mydataservice.com.cn/index.html', '_blank')
  } else {
    window.open(
      'https://ai.aigongtongti.org.cn/archives/0681dd1c-305a-4d11-9caa-7d87e83fbf92',
      '_blank'
    )
  }
}

const partners = ref([
  {
    photo: 'https://p2.ssl.qhimg.com/t11b673bcd65ab8a376bc83e517.png',
    id: 'snow'
  },
  {
    photo: 'https://p5.ssl.qhimg.com/t11b673bcd6d1d64ea812cf05c4.png',
    id: 'service'
  },
  {
    photo: 'https://p2.ssl.qhimg.com/t11b673bcd604d30d41cb443db4.png',
    id: 'ai'
  }
])

onMounted(() => {
  window.addEventListener('scroll', handleScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
onBeforeMount(async () => {
  await fetch()
})

function fetch() {
  getRecruit('ZHdKeG1Xc1hkbjJ1d3YxZ3VlWDFuUT09OjqlcZEMpk30dFSNP9/NAE69')
    .then((res) => {
      let arr = JSON.parse(res.data.data.data)
      // console.log('res', arr)

      aiClass.value = arr[0]
      safeClass.value = arr[1]
      imgs.value = arr[2]
    })
    .catch(() => {})
}
</script>

<style lang="scss" scoped>
.mobile {
  width: 100%;
  &Header {
    height: 74px;
    padding: 20px 0 18px 24px;
    &Logo {
      width: 129px;
    }
  }
  &Banner {
    width: 100%;
  }
  &Body {
    padding: 0 24px;
    &Overall {
      width: 100%;
      margin: 55px 0 47px;
      &Detail {
        width: 100%;
      }
    }
    &Class {
      width: 100%;
      margin: 84px 0 24px;
      &Detail {
        width: 100%;
      }
    }
    &Signup {
      width: 100%;
      margin: 86px 0 84px;
    }
  }
  &Qr {
    padding: 0 48px 93px;
    &Code {
      width: 100%;
    }
  }
  &Partner {
    padding: 0 23px 66px;
    margin-bottom: 115px;
    &Title {
      width: 167px;
      margin: 0 auto 37px;
      display: block;
    }
    &Box {
      display: flex;
      justify-content: space-between;
      &Item {
        width: 31%;
      }
    }
  }
  &Teach {
    margin-top: 79px;
    &Title {
      width: 169px;
      display: block;
      margin: 0 auto 50px;
    }
  }
  &Footer {
    position: fixed;
    bottom: 0;
    z-index: 999;
    height: 115px;
    padding: 33px 24px 18px;
    background: linear-gradient(180deg, rgb(232, 249, 255) 0%, rgb(255, 255, 255) 46.948%);
  }
  &JumpBottom {
    width: 100%;
  }
}

.aiClass {
  &Head {
    width: 100%;
    height: 263px;
    background-image: url('https://p1.ssl.qhimg.com/t11b673bcd6f5db00abba93f7fd.png'); /* 设置背景图片 */
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 14px;
    &Type {
      margin-left: 23px;
      color: rgb(255, 255, 255);
      font-size: 24px;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: 0px;
      text-align: justify;
    }
    &Box {
      margin-top: 31px;
      height: 50px;
      display: flex;
      &Name {
        margin-top: 14px;
        margin-left: 22px;
        margin-right: 16px;
        color: rgb(0, 0, 0);
        font-size: 30px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0px;
        text-align: left;
      }
      &Avtar {
        z-index: 20;
        width: 31px;
        height: 27px;
        display: block;
        margin: 0 auto;
      }
      &Level {
        color: rgb(0, 0, 0);
        margin-top: 10px;
        font-size: 14px;
        font-weight: 500;
        line-height: 14px;
        letter-spacing: 0px;
        text-align: left;
        z-index: 20;
      }
    }
    &Title {
      width: 172px;
      position: absolute;
      z-index: 20;
      margin-top: 9px;
      left: 22px;
      color: rgb(0, 0, 0);
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0px;
      text-align: left;
    }
  }
  &Avtar {
    width: 163px;
    position: absolute;
    z-index: 10;
    right: -9px;
    top: -20px;
  }
  &Intro {
    border-radius: 12px;
    box-shadow: 0px 10px 25px 0px rgba(47, 184, 236, 0.15);
    background: rgb(255, 255, 255);
    position: absolute;
    top: 200px;
    left: 10px;
    right: 10px;
    z-index: 60;
    color: rgb(0, 0, 0);
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0px;
    text-align: justify;
    padding: 21px 15px 19px 13px;
  }
  &List {
    padding: 240px 9px 46px;
    border-radius: 0px 0px 15.99px 15.99px;
    background: rgb(245, 248, 251);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    gap: 20px 0;
    &Item {
      min-width: 148px;
      height: 199px;
      position: relative;
      &Avtar {
        width: 91px;
        display: block;
        position: absolute;
        top: 0;
        z-index: 50;
        left: 50%; /* 左边缘移动到父元素的中心 */
        transform: translateX(-50%); /* 向左移动自身宽度的50%以居中 */
      }
      &Box {
        // z-index: 20;
        margin-top: 44px;
        width: 177px;
        height: 155px;
        box-sizing: border-box;
        border-left: 1px solid rgba(255, 255, 255, 0.5);
        border-top: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 12px;
        backdrop-filter: blur(40px);
        background: linear-gradient(180deg, rgb(186, 229, 246), rgba(186, 229, 246, 0.2) 100%);
        &Name {
          margin-top: 67px;
          color: rgb(0, 0, 0);
          font-size: 14px;
          font-weight: 700;
          line-height: 14px;
          letter-spacing: 0px;
          text-align: center;
        }
        &Intro {
          width: 118px;
          color: rgb(0, 0, 0);
          font-size: 9.83px;
          font-weight: 400;
          line-height: 15.45px;
          letter-spacing: 0px;
          text-align: center;
          margin: 14px auto 17px;
        }
      }
    }
  }
}

.safeClass {
  margin-top: 43px;
  &Head {
    width: 100%;
    height: 263px;
    background-image: url('https://p0.ssl.qhimg.com/t11b673bcd63bd3d82dd4948779.png'); /* 设置背景图片 */
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 14px;
    &Type {
      margin-left: 23px;
      color: rgb(255, 255, 255);
      font-size: 24px;
      font-weight: 700;
      line-height: 28px;
      letter-spacing: 0px;
      text-align: justify;
    }
    &Box {
      margin-top: 50px;
      height: 50px;
      display: flex;
      &Name {
        margin-top: 14px;
        margin-left: 22px;
        margin-right: 16px;
        color: rgb(0, 0, 0);
        font-size: 30px;
        font-weight: 700;
        line-height: 36px;
        letter-spacing: 0px;
        text-align: left;
      }
      &Avtar {
        z-index: 20;
        width: 31px;
        height: 27px;
        display: block;
        margin: 0 auto;
      }
      &Level {
        color: rgb(0, 0, 0);
        margin-top: 10px;
        font-size: 14px;
        font-weight: 500;
        line-height: 14px;
        letter-spacing: 0px;
        text-align: left;
        z-index: 20;
      }
    }
    &Title {
      width: 137px;
      position: absolute;
      z-index: 20;
      margin-top: 9px;
      left: 22px;
      color: rgb(0, 0, 0);
      font-size: 14px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0px;
      text-align: left;
    }
  }
  &Avtar {
    width: 177px;
    position: absolute;
    z-index: 10;
    right: 0;
    top: -20px;
  }
  &Intro {
    border-radius: 12px;
    box-shadow: 0px 10px 25px 0px rgba(47, 184, 236, 0.15);
    background: rgb(255, 255, 255);
    position: absolute;
    top: 230px;
    left: 10px;
    right: 10px;
    z-index: 60;
    color: rgb(0, 0, 0);
    font-size: 14px;
    font-weight: 400;
    line-height: 28px;
    letter-spacing: 0px;
    text-align: justify;
    padding: 21px 15px 19px 13px;
  }
  &List {
    margin-bottom: 45px;
    padding: 250px 9px 46px;
    border-radius: 0px 0px 15.99px 15.99px;
    background: rgb(245, 248, 251);
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
    gap: 20px 0;
    &Item {
      min-width: 148px;
      height: 199px;
      &Avtar {
        width: 91px;
        display: block;
        position: absolute;
        top: 0;
        z-index: 50;
        left: 50%; /* 左边缘移动到父元素的中心 */
        transform: translateX(-50%); /* 向左移动自身宽度的50%以居中 */
      }
      &Box {
        z-index: 20;
        margin-top: 44px;
        width: 177px;
        height: 155px;
        box-sizing: border-box;
        border-left: 1px solid rgba(255, 255, 255, 0.5);
        border-top: 1px solid rgba(255, 255, 255, 0.5);
        border-radius: 12px;
        background: linear-gradient(180deg, rgb(176, 233, 210), rgba(176, 233, 210, 0.2) 100%);
        &Name {
          margin-top: 67px;
          color: rgb(0, 0, 0);
          font-size: 14px;
          font-weight: 700;
          line-height: 14px;
          letter-spacing: 0px;
          text-align: center;
        }
        &Intro {
          width: 118px;
          color: rgb(0, 0, 0);
          font-size: 9.83px;
          font-weight: 400;
          line-height: 15.45px;
          letter-spacing: 0px;
          text-align: center;
          margin: 14px auto 17px;
        }
      }
    }
  }
}
</style>
